module.exports = __webpack_public_path__ + "static/media/01_african_elephant.3be1c94a.png";